import { watch } from "vue";
import { createGlobalState } from "@vueuse/core";

import config from "@/config";
import useAuthState from "@/composables/state/authState";

import {
  AnalyticsService,
  FullStoryAnalyticsProvider,
  PostHogAnalyticsProvider,
} from "@lendflow/utils/analytics";

const analyticsService = new AnalyticsService([
  new FullStoryAnalyticsProvider(),
  new PostHogAnalyticsProvider({
    appVersion: config.appVersion,
  }),
]);

export const useAnalyticsState = createGlobalState(() => {
  const { loggedInUser } = useAuthState();

  watch(loggedInUser, (value) => {
    const payload = value ? { id: value.id, email: value.email } : null;
    analyticsService.trackUserChange(payload);
  });

  return {
    trackEvent: analyticsService.trackEvent,
    trackUserPropertiesChange: analyticsService.trackUserPropertiesChange,
  };
});
